import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { wordpressBaseUrl } from '../../wordpressApiConfig/wordpressApiConfig';
import { verifyToken } from '../../http';
import { saveUser } from '../../Redux/User-slice/User-slice';
import { getBen } from '../Landing/Otp/Action/getBen';
import { getAllBen } from '../Landing/Otp/Action/getAllBen';
import { getSubscriber } from '../Landing/Otp/Action/getSubscriber';
import { saveSbsSubscriberData } from '../../Redux/B2CSubscriber-Slice/Subscriber-sbs-slice';
const styles = {
    wrapper: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column' as 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
    },
    logo: {
        width: '120px',
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        // marginBottom: '20px',
        padding:"20px",
        // border: '2px solid #007bff',
    },
    message: {
        fontSize: '18px',
        fontWeight: 500,
        color: '#333',
    },
};


const SamlValidation = () => {
    const wpBaseUrl = wordpressBaseUrl();
    const subscriberData = useSelector(
        (state: any) => state.subscriber
    );
    const userData = useSelector((state: any) => state.user, shallowEqual);
    const beneficiaryData = useSelector(
        (state: any) => state.beneficiary, shallowEqual
    );
    const b2cSubscriberData = useSelector((state: any) => state.sbsSusbscriberm, shallowEqual);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [checkingAuth, setCheckingAuth] = useState(true);
    // console.log('userData:', userData);
    const hasFetchedUser = useRef(false);
    useEffect(() => {
        if (hasFetchedUser.current) return;
        hasFetchedUser.current = true;
        const checkAndFetchUser = async () => {
            // If user data not in Redux
            if (!userData || !Object.keys(userData).length) {   
                try {
                    const getUserData: any = await verifyToken();
                    // console.log('getUserData:', getUserData.data)
                    dispatch(saveUser(getUserData.data));
                    localStorage.setItem('userData',JSON.stringify(getUserData.data));
                    await getBen(getUserData.data.beneficiaryId, dispatch);
                    await getAllBen(getUserData.data.subscriberId, dispatch);
                    setCheckingAuth(false);
                    if (getUserData.data.userRole === "BENEFICIARY_ADMIN") {
                        let subscriptionData = await getSubscriber(getUserData.data.subscriberId);
                        dispatch(saveSbsSubscriberData(subscriptionData));
                        if (subscriptionData?.isSubscriptionActive !== undefined && subscriptionData?.isSubscriptionActive === false) {
                            // alert("check-1----from--opt")
                            return navigate("/subscription")
                        }
                    };
                } catch (error) {
                    console.error("Token invalid or fetch failed:", error);
                    window.location.href = wpBaseUrl + "/home";
                    setCheckingAuth(false);
                    return;
                }
            } else if (!subscriberData || !Object.keys(subscriberData).length) {
                await getBen(userData.beneficiaryId, dispatch);
            } else if (!beneficiaryData || !Object.keys(beneficiaryData).length) {
                await getAllBen(userData.subscriberId, dispatch);
            }

            setCheckingAuth(false);
        };

        checkAndFetchUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (checkingAuth) {
        return (
            <div style={styles.wrapper}>
                <img
                    src="/Images/logo-transparent3.png"
                    alt="Logo"
                    style={{ ...styles.logo, animation: 'pulse 1.5s ease-in-out infinite' }}
                />
                <p style={styles.message}>Verifying your credentials...</p>
            </div>
        );
    }

    if (!Object.keys(subscriberData).length) {
        window.location.href = wpBaseUrl + "/home"
        return null;
    }
    if (b2cSubscriberData?.typeOfSubscriber === "Business to customer" && b2cSubscriberData?.isSubscriptionActive === false) {
        return <Navigate to={'/subscription'} />
    }

    if (userData.numberOfBenAllowed === 0) {
        if ((beneficiaryData?.length < 2) && (userData?.addBeneficiaryAllowed === true)) {
            return <Navigate to={"/addBeneficiaries"} />;
        }
    }
    else {
        if ((beneficiaryData?.length < userData?.numberOfBenAllowed) && (userData?.addBeneficiaryAllowed === true) && (beneficiaryData?.length < 2)) {
            return <Navigate to={"/addBeneficiaries"} />;
        }
    }

    return <Navigate to={"/dashboard"} />;

    // return (
    //     <div style={styles.wrapper}>
    //         <img
    //             src="/Images/logo-transparent3.png"
    //             alt="Logo"
    //             style={{ ...styles.logo, animation: 'pulse 1.5s ease-in-out infinite' }}
    //         />
    //         <p style={styles.message}>Verifying your credentials...</p>
    //     </div>
    // );


}

export default SamlValidation
